<template>
    <nav class="navbar is-fixed-bottom flex-center push-top push-extra">
      <router-link to="/honoree-list/hall-of-fame-inductee" :class="{whiteBG: this.$router.currentRoute.name === 'all-honorees'}">BREITBARD HALL OF FAME</router-link>
      <router-link to="/all-honorees" :class="{whiteBG: this.$router.currentRoute.name === 'about'}"><span>ALL HONOREES</span></router-link>
      <router-link to="/about">ABOUT</router-link>
    </nav>
</template>

<script>
export default {
    name: 'app-nav'
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
@import '@/assets/scss/helpers.scss';

nav {
  height: 50px;
  background-color: $red;
  overflow: hidden;
  > a {
    display: flex;
    align-items: center;
    position: relative;
    height: 100%;
    padding-left: 20px;
    background-color: $red;
    background: url('/images/nav-shadow-all-red.jpg') no-repeat top right;
    background-size: 50px 53px;
    &:first-of-type {
      flex: 3;
    }
    &:nth-of-type(2) {
      flex: 2;
      span {
        @media screen and (max-width: 400px) {
          position: relative;
          left: -10px;
        }
      }      
    }
    &:last-of-type {
      flex: 1;
      background-image: none;
    }
    &.whiteBG {
      background: url('/images/nav-shadow-white-right.jpg') no-repeat top right;
      background-size: 50px 53px;
    }
    @media screen and (max-width: 500px) {
      padding-left: 12px;
    }
    @media screen and (max-width: 400px) {
      padding-left: 10px;
    }
  }
}
a {
  color: #fff;
}
a.router-link-active {
  color: $blue;
  &:first-of-type {
    background: #fff url('/images/nav-shadow-white-left.jpg') no-repeat top right;
    background-size: 50px 53px;
  }
  &:nth-of-type(2) {
    background: #fff url('/images/nav-shadow-white-left.jpg') no-repeat top right;
    background-size: 50px 53px;
  }
  &:last-of-type {
    background: #fff;
  }
}
</style>